import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ConfirmEnrollMixBundleBox = styled(Box)`
  padding: 16px;

  .close-box {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .content-box {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .title-text {
    margin-top: 21.67px;
    white-space: pre-wrap;
    text-align: center;
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;

    @media only screen and (min-width: 768px) {
      width: 429px;
    }
  }

  .detail-text {
    margin-top: 10px;
    font-family: Lanna;
    text-align: center;
    font-size: 18px;
    line-height: 22px;
    white-space: pre-wrap;

    @media only screen and (min-width: 768px) {
      width: 429px;
      white-space: unset;
    }
  }

  .button-box {
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: space-between;

    @media only screen and (min-width: 768px) {
      gap: 50px;
    }
  }
`;
